// extracted by mini-css-extract-plugin
module.exports = {"bbyyfpx":"bbyyfpx","rdc1r9a":"rdc1r9a","svgx8vc":"svgx8vc","f1e9ocz1":"f1e9ocz1"};